"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.putDistributorCatalog = void 0;
const routes_1 = require("../../routes");
const putDistributorCatalog = (client) => async (params, payload, { correlationfileid, filename, fileurl } = {}) => {
    const formData = new FormData();
    formData.append('file', payload);
    if ('subTaskId' in params) {
        const v2Endpoint = routes_1.ENDPOINTS.PUT_COOPERATIVE_CATALOG_V2;
        const url = v2Endpoint.applyParams(params);
        const response = await client.put(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                correlationfileid,
                filename,
                fileurl,
            },
        });
        return response.data;
    }
    else {
        const v1Endpoint = routes_1.ENDPOINTS.PUT_DISTRIBUTOR_CATALOG;
        const url = v1Endpoint.applyParams(params);
        const response = await client.put(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                correlationfileid,
                filename,
                fileurl,
            },
        });
        return response.data;
    }
};
exports.putDistributorCatalog = putDistributorCatalog;
